/**
 * Carrega o chunk pesado do @react-pdf/renderer apenas quando precisamos.
 * Pré-carregamos no mount de /success (paralelo à animação) e disparamos
 * o download quando o usuário clica no botão.
 */

type PdfModule = typeof import('../components/CertificatePDF');

let modulePromise: Promise<PdfModule> | null = null;

export function preloadPdf(): Promise<PdfModule> {
  if (!modulePromise) {
    modulePromise = import('../components/CertificatePDF');
  }
  return modulePromise;
}
